// action types
export const types = {
    GET_AUTH: "GET_AUTH",

    LIST: 'LIST',
    LIST_SUCCESS: 'LIST_SUCCESS',

    LIST_LIST_MENU: 'LIST_LIST_MENU',
    LIST_LIST_MENU_SUCCESS: 'LIST_LIST_MENU_SUCCESS',

    LIST_VERTICAL_MENU: 'LIST_VERTICAL_MENU',
    LIST_VERTICAL_MENU_SUCCESS: 'LIST_VERTICAL_MENU_SUCCESS',

    LIST_FORM_INFO: 'LIST_FORM_INFO',

    LIST_BIRTHDAY: 'LIST_BIRTHDAY',
    LIST_BIRTHDAY_SUCCESS: 'LIST_BIRTHDAY_SUCCESS',
};

export function getAuth(params, cb) {
    return {
        type: types.GET_AUTH,
        params,
        cb
    }
}

export function getList(cb) {
    return {
        type: types.LIST,
        cb
    }
}

export function getListMenu(params,cb) {
    return {
        type: types.LIST_LIST_MENU,
        params,
        cb
    }
}

export function getVerticalMenu(params,cb) {
    return {
        type: types.LIST_VERTICAL_MENU,
        params,
        cb
    }
}

export function getFormInfo(cb) {
    return {
        type: types.LIST_FORM_INFO,
        cb
    }
}

export function getListBirthday(cb) {
    return {
        type: types.LIST_BIRTHDAY,
        cb
    }
}
